import { createTRPCReact } from '@trpc/react-query'
import type { AppRouter } from '../../../../backend-2/src/trpc/_app'

export const trpc = createTRPCReact<AppRouter>()
